import {
  Button,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Td,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
import axios from 'axios';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import AppConfig from "config";
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ChatComponent from './chat_componente';
import SingleTranscriptController from './controllers/SingleAudioController';

const pointerTranscript = `
  .destaque:hover:not(.highlighted-text) {
    background-color: #d0d0d05e;
  }
`;
const textTime = `
  .time {
    background-color: unset;
    background-color: #8f8f8f3b;
    font-size: 0.7em;
    cursor: normal;
  }
  .time:hover {
    background-color: #8f8f8f3b;
    cursor: normal;
  }
`;

Number.prototype.HHMMSS = function () {
  return new Date(this * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];
};

function TranscriptsView(props) {
  const h = window.location.hash;
  const n = parseInt(h.split('/')[h.split('/').length - 1]);
  const i = props.location.state && props.location.state.numero ? props.location.state.numero : n;

  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { Audit_id } = useParams();
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    return () => {
      if (intervalId !== null) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  const fetchMessages = async (i) => {
    try {
      const jwtToken = localStorage.getItem('access_token');
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + 'chat/get_messages',
        {
          idtranscripts: i,
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      const messagesFromEndpoint = response.data.result || [];
      setChatMessages(messagesFromEndpoint);
    } catch (error) {
      console.error('Erro ao buscar mensagens da IA:', error);
    }
  };

  useEffect(() => {
    const fetchData = async (i) => {
      try {
        const profiles = await SingleTranscriptController.listTranscriptsSearchAudio(i);
        setData(profiles);
        setOriginalData(profiles);
        setFilteredData(profiles);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData(i);
  }, [Audit_id]);

  useEffect(() => {
    setFilteredData(originalData);
  }, [originalData]);

  useEffect(() => {
    const fetchMessagesInterval = () => {
      fetchMessages(i);
    };

    fetchMessages(i);

    const intervalId = setInterval(fetchMessagesInterval, 9000);
    setIntervalId(intervalId);

    return () => {
      clearInterval(intervalId);
    };
  }, [i]);

  const interactWithGPT = async (idtranscript, newMessage) => {
    try {
      const jwtToken = localStorage.getItem('access_token');
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + 'chat/send_message',
        {
          idtranscripts: idtranscript,
          message: newMessage,
          user: 'Você',
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
    } catch (error) {
      console.error('Erro ao interagir com a IA:', error);
    }
  };

  let highlightTextColor = useColorModeValue("#85bbed", "white");
  const highlightStyle = `
    .highlighted-text {
      background-color: ${highlightTextColor};
      color: #000000;
    }
  `;

  return (
    <Flex height="100%" width="100%">
      <Card>
        <Flex direction='column' height="100%" width="100%" overflowY={'auto'}>
          <Link to="/admin/audios">
            <Button colorScheme="blue" borderRadius="lg" marginRight={4}>Voltar</Button>
          </Link>
          <CardHeader p="6px 0px 22px px">
            <Flex flexDirection="column" mb={4}>
              <style>{highlightStyle}</style>
              <style>{pointerTranscript}</style>
              <style>{textTime}</style>
            </Flex>
            <Tabs style={{ width: '100%' }}>
              <TabList>
                <Tab flex="1" style={{ background: "unset", boxShadow: "unset", color: "unset", border: "unset" }}>
                  <Button flex="1" colorScheme='blue' marginRight="2">Transcrição</Button>
                </Tab>
                <Tab flex="1" style={{ background: "unset", boxShadow: "unset", color: "unset", border: "unset" }}>
                  <Button flex="1" colorScheme='blue' marginRight="2">Interagir</Button>
                </Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <CardBody>
                    {filteredData ? (
                      <TranscriptsRow
                        key={filteredData.idtranscripts}
                        transcript={filteredData}
                        setData={setData}
                        data={data}
                        currentTime={currentTime}
                        setIsPlaying={setIsPlaying}
                        isPlaying={isPlaying}
                        setCurrentTime={setCurrentTime}
                      />
                    ) : (
                      <Tr>
                        <Td colSpan={6}>Nenhum dado disponível</Td>
                      </Tr>
                    )}
                  </CardBody>
                </TabPanel>
                <TabPanel>
                  <CardBody>
                    <ChatComponent
                      messages={chatMessages}
                      idtranscript={filteredData.idtranscripts}
                      setMessages={setChatMessages}
                      user={filteredData.user}
                      onSendMessage={(newMessage) => interactWithGPT(filteredData.idtranscripts, newMessage)}
                    />
                  </CardBody>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </CardHeader>
        </Flex>
      </Card>
    </Flex>
  );
}

function TranscriptsRow({
  transcript,
  isPlaying,
  currentTime,
  setIsPlaying,
  setCurrentTime,
}) {
  const [audioUrl, setAudioUrl] = useState('');

  useEffect(() => {
    const fetchAudio = async () => {
      try {
        const url = await SingleTranscriptController.getAudio(transcript.idtranscripts);
        setAudioUrl(url);
      } catch (error) {
        console.error('Erro ao buscar o áudio:', error);
      }
    };

    fetchAudio();
  }, [transcript.idtranscripts]);

  useEffect(() => {
    const audioElement = document.getElementById(`audio-${transcript.idtranscripts}`);

    const updateCurrentTime = () => {
      if (audioElement) {
        setCurrentTime(audioElement.currentTime);
      }
    };

    if (audioElement) {
      audioElement.addEventListener('timeupdate', updateCurrentTime);

      return () => {
        audioElement.removeEventListener('timeupdate', updateCurrentTime);
      };
    }
  }, [transcript.idtranscripts, isPlaying, setCurrentTime]);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const handleTimeClick = (startTime) => {
    const audioElement = document.getElementById(`audio-${transcript.idtranscripts}`);
    if (audioElement) {
      audioElement.currentTime = startTime;
      setCurrentTime(startTime);
      setIsPlaying(true);
    }
  };

  const getDisplayText = () => {
    const lines = transcript.transcript_text
      ? transcript.transcript_text.split('\n')
      : [];

    return (
      <div key={transcript.idtranscripts}>
        {lines.map((line, index) => {
          const tempoObserver = line.match(/\[(\d+\.\d+)s -> (\d+\.\d+)s\]/);

          if (tempoObserver && tempoObserver.length === 3) {
            const startTime = parseFloat(tempoObserver[1]);
            const endTime = parseFloat(tempoObserver[2]);

            const isInInterval =
              currentTime >= startTime && currentTime <= endTime;

            return (
              <span key={index} style={{ cursor: 'pointer' }} onClick={() => handleTimeClick(startTime)}>
                <span className="time">{startTime.HHMMSS()}</span>
                <span className={isInInterval ? 'highlighted-text destaque' : 'destaque'}>
                  {' ' + line.replace(/(\[(\d+\.\d+)s -> (\d+\.\d+)s\])/g, '')}
                </span>
                <br />
              </span>
            );
          }

          return (
            <span key={index}>
              {line}
              <br />
            </span>
          );
        })}
      </div>
    );
  };

  return (
    <Flex direction="column" p="5" borderWidth="1px" borderRadius="lg" width="100%">
      <audio
        id={`audio-${transcript.idtranscripts}`}
        controls
        src={audioUrl}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
      >
        Seu navegador não suporta o elemento de áudio.
      </audio>
      <div style={{ marginTop: '20px', width: '100%' }}>
        ID: {transcript.idtranscripts}
      </div>
      {transcript && (
        <div style={{ width: '100%' }}>
          {transcript.recording_path && /^\d+$/.test(transcript.recording_path.split('/').pop().split('-')[0])
            ? transcript.recording_path.split('/').pop().split('-')[0]
            : ''}
        </div>
      )}
      <div style={{ width: '100%' }}>Data: {formatDate(transcript.date_start)}</div>
      <div style={{ width: '100%' }}>Ficha: {transcript.audit_nome}</div>
      <div style={{ whiteSpace: 'nowrap', width: '100%' }}>Palavras + faladas: {transcript.word_cloud_3}</div>
      <div style={{ marginBottom: '8px', whiteSpace: 'pre-line', width: '100%' }}>
        <div>Transcrição:</div><br />
        {getDisplayText()}
      </div>
    </Flex>
  );
}

export default TranscriptsView;